import React, {Fragment, useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import BotoneraBottom from '../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import {Flex, ContBottom, Button, Ilustracion } from '../../Css/MetodosCSS/StyledRimaLexica';

const instrucciones = 'Te voy a mostrar un dibujo y vamos a buscar cuál de los otros dibujos rima con él. Veamos juntos un ejemplo';
const miniInstrucciones = '';

const SCR1 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [randomImagen, setRandomImagen] = useState('')
    const [indexes, setIndexes] = useState();
    const [resultado, setResultado] = useState([]);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const ayuda_imagen = useSelector((state) => state.configuracion.ayuda_imagen);

    const resultadoBase = [
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", palabra_usada:"", puntaje:"", ejemplo:""}
    ];

    const verificar = (e, img) => {
        e.preventDefault();
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_2;
            newList[count-1].palabra_usada = img;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        if(img.toUpperCase() !== comparar.palabra_2.toUpperCase()) {
            console.log('mal');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_2;
            newList[count-1].palabra_usada = img;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        } else {
            console.log("bien");
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_2;
            newList[count-1].palabra_usada = img;
            newList[count-1].puntaje = "1";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        }
    }

    useEffect(() => {
        dispatch(setearEjercicioAction('SCR1') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])

    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])


    useEffect(() => {
        if(finalizar){
            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'ejercicio': "SCR1",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            };
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    useEffect(() => {
        if(comparar === undefined){
            return;
        }
        const newList = JSON.parse(JSON.stringify(comparar));
        const newComparar = [
            {id:'1', imagen_url:newList.imagen_url_2, palabra:newList.palabra_2, ayuda_imagen: newList.ayuda_imagen_2},
            {id:'2', imagen_url:newList.imagen_url_3, palabra:newList.palabra_3, ayuda_imagen: newList.ayuda_imagen_3},
            {id:'3', imagen_url:newList.imagen_url_4, palabra:newList.palabra_4, ayuda_imagen: newList.ayuda_imagen_4}
        ]
        
        setRandomImagen(
            newComparar
        )
    }, [comparar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} ayuImagen={true} />
            {iniciar
                ?   
                <Fragment>
                    {comparar.ejemplo ? 
                    <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                        Ejemplo
                    </Flex>
                    : null
                    }
                    
                    <Flex height="100%" direction="column">
                        <Flex margin="3rem 0px 6rem 0px" direction="column">
                            <Ilustracion src={`/img/${comparar.imagen_url_1}.png`} width="15vw"/>
                            {ayuda_imagen ? 
                                <div>{comparar.ayuda_imagen_1}</div>
                            : null}
                        </Flex>
                        
                        <Flex direction="row">
                        {randomImagen.map((item, index) =>
                            <Button border={item.border} borderradius={item.border}
                                key={item.id}
                                disabled={disable}
                                onClick={(e) => verificar(e, item.imagen_url, index)}
                            >
                                <Ilustracion src={`/img/${item.imagen_url}.png`}  width="8vw" margin="0px 30px"/>
                                {ayuda_imagen ? 
                                    <div>{item.ayuda_imagen}</div>
                                : null}
                            </Button>
                        )}
                        </Flex>
                    </Flex>
                    <ContBottom><BotoneraBottom miniInstrucciones={miniInstrucciones} /></ContBottom>
                </Fragment>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR1;